import { isNumber } from 'lib/typeguards';

const numberFormatter = new Intl.NumberFormat('en-GB', {
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
});

export function decimalValueFormatter(params: { value: string | number }) {
    return isNumber(params.value) ? numberFormatter.format(params.value) : '-';
}

export function numberValueFormatter(params: { value: string | number }) {
    return isNumber(params.value) ? String(params.value) : '-';
}
